import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import Playbooks from '../views/Playbook.vue'
import LogIn from '../views/LogIn.vue'
import AdminLogIn from '../views/AdminLogIn.vue'
import EditProcess from '../views/EditProcess.vue'
import AIReviewDraft from '../views/AIReviewDraft.vue'
import EditTimeline from '../views/EditTimeline.vue'
import NeedsApproval from '../views/NeedsApproval.vue'
import EditSheet from '../views/EditSheet.vue'
import Users from '../views/Users.vue'
import PublicUsers from '../views/PublicUsers.vue'
import Nodes from '../views/Nodes.vue'
import Folders from '../views/Folders.vue'
import FixNodes from '../views/FixNodes.vue'
import Configuration from '../views/Configuration.vue'
import Notifications from '../views/Notifications.vue'
import CompanySheet from '../views/CompanySheet.vue'
import CompanySheets from '../views/CompanySheets.vue'
import CompanyBoards from '../views/CompanyBoards.vue'
import MyTaskManager from '../views/MyTaskManager.vue'
import BoardTemplates from '@/views/BoardTemplates.vue'
import RoleSheetTemplates from '@/views/RoleSheetTemplates.vue'
import CompanyBoard from '../views/CompanyBoard.vue'
import ComingSoon from '@/views/ComingSoon.vue'
import Forms from '@/views/Forms.vue'
import Employees from '@/views/Employees.vue'
import ViewEmployee from '@/views/Employee.vue'
import Onboardings from '@/views/Onboardings.vue'
import Onboarding from '@/views/Onboarding.vue'
import SkillsMatrices from '@/views/SkillsMatrices.vue'
import SkillsMatrix from '@/views/SkillsMatrix.vue'
import EditTeamHubLinks from '@/views/EditTeamHubLinks.vue'
import EditChecklist from '@/views/EditChecklist.vue'
import AIHub from '@/views/AIHub.vue'
import AITrainer from '@/views/AITrainer.vue'
import Announcements from '@/views/Announcements.vue'
import Classrooms from '@/views/Classrooms.vue'
import Classroom from '@/views/Classroom.vue'
import AccountabilityChart from '@/views/AccountabilityChart.vue'
import Meetings from '@/views/Meetings.vue'
import Scoreboard from '@/views/Scoreboard.vue'
import CompetitiveAnalysis from '@/views/CompetitiveAnalysis.vue'
import UsageStats from '@/views/UsageStats.vue'
import MeetingTemplates from '@/views/MeetingTemplates.vue'
import Celebrations from '@/views/Celebrations.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/celebrations',
    name: 'Celebrations',
    component: Celebrations
  },
  {
    path: '/meetings',
    name: 'Meetings',
    component: Meetings
  },
  {
    path: '/scoreboard',
    name: 'Scoreboard',
    component: Scoreboard
  },
  {
    path: '/competitive-analysis',
    name: 'CompetitiveAnalysis',
    component: CompetitiveAnalysis
  },
  {
    path: '/usage',
    name: 'UsageStats',
    component: UsageStats
  },
  {
    path: '/meeting-templates',
    name: 'MeetingTemplates',
    component: MeetingTemplates
  },
  {
    path: '/ai-hub',
    name: 'AIHub',
    component: AIHub
  },
  {
    path: '/ai-training',
    name: 'AITrainer',
    component: AITrainer
  },
  {
    path: '/',
    redirect: '/playbook/home'
    /*name: 'Home',
    component: Home*/
  },
  {
    path: '/classroom/:id',
    name: 'ClassroomView',
    component: Classroom
  },
  {
    path: '/employee/:id',
    name: 'ViewEmployee',
    component: ViewEmployee
  },
  {
    path: '/classrooms',
    name: 'ClassroomsView',
    component: Classrooms
  },
  {
    path: '/announcements',
    name: 'AnnouncementsView',
    component: Announcements
  },
  {
    path: '/edit-team-hub-links',
    name: 'EditTeamHubLinks',
    component: EditTeamHubLinks
  },
  {
    path: '/skills-matrix',
    name: 'SkillsMatrices',
    component: SkillsMatrices
  },
  {
    path: '/skills-matrix/:id',
    name: 'SkillsMatrix',
    component: SkillsMatrix
  },
  {
    path: '/onboarding',
    name: 'OnboardingsView',
    component: Onboardings
  },
  {
    path: '/onboarding/:id',
    name: 'OnboardingView',
    component: Onboarding
  },
  {
    path: '/employees',
    name: 'EmployeesView',
    component: Employees
  },
  {
    path: '/accountability-chart',
    name: 'AccountabilityChartView',
    component: AccountabilityChart
  },
  {
    path: '/forms',
    name: 'FormsView',
    component: Forms
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon
  },
  {
    path: '/configuration',
    name: 'Configuration',
    component: Configuration
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications
  },
  {
    path: '/login',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/fix-nodes',
    name: 'FixNodes',
    component: FixNodes
  },
  {
    path: '/review',
    name: 'NeedsApproval',
    component: NeedsApproval
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/standard-users',
    name: 'PublicUsers',
    component: PublicUsers
  },
  {
    // Old address (from before public users were called standard users in the UI): bookmarks and older emails
    path: '/public-users',
    redirect: '/standard-users'
  },
  {
    path: '/admin-login',
    name: 'AdminLogIn',
    component: AdminLogIn
  },
  {
    path: '/playbook/:node',
    name: 'Playbook',
    component: Playbooks
  },
  {
    path: '/company-sheet/:slug',
    name: 'CompanySheet',
    component: CompanySheet
  },
  {
    path: '/deck/:slug',
    name: 'CompanyBoard',
    component: CompanyBoard
  },
  // Old board links (bookmarks, texts, emails), with their ?openCard= etc.
  {
    path: '/company-board/:slug',
    redirect: (to: any) => ({ path: '/deck/' + to.params.slug, query: to.query, hash: to.hash })
  },
  {
    path: '/company-sheets',
    name: 'CompanySheets',
    component: CompanySheets
  },
  {
    path: '/decks',
    name: 'CompanyBoards',
    component: CompanyBoards
  },
  // Straight to your own task manager (Decks if you haven't set one up): for links from outside the app
  {
    path: '/my-task-manager',
    name: 'MyTaskManager',
    component: MyTaskManager
  },
  {
    path: '/company-boards',
    redirect: (to: any) => ({ path: '/decks', query: to.query, hash: to.hash })
  },
  {
    path: '/board-templates',
    name: 'BoardTemplates',
    component: BoardTemplates
  },
  {
    path: '/role-sheet-templates',
    name: 'RoleSheetTemplates',
    component: RoleSheetTemplates
  },
  {
    path: '/edit-process/:node',
    name: 'EditProcess',
    component: EditProcess
  },
  {
    path: '/edit-timeline/:node',
    name: 'EditTimeline',
    component: EditTimeline
  },
  {
    path: '/edit-sheet/:node',
    name: 'EditSheet',
    component: EditSheet
  },
  {
    path: '/edit-checklist/:node',
    name: 'EditChecklist',
    component: EditChecklist
  },
  {
    path: '/folders',
    name: 'Folders',
    component: Folders
  },
  {
    path: '/nodes/:type',
    name: 'Nodes',
    component: Nodes
  },
  {
    path: '/ai-review/:jobId',
    name: 'AIReviewDraft',
    component: AIReviewDraft
  },
  {
    path: "/:catchAll(.*)",
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
